import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Instagram, MapPin, Phone, Globe } from 'lucide-react';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-ocean-dark text-white pt-16 pb-8" data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-103">
          {/* Brand 1 */}
          <div data-id="element-104">
            <div className="flex items-center gap-3 mb-4" data-id="element-105">
              <img src="https://cdn.magicpatterns.com/uploads/fDWRYDuPXFdmht4Kx9GQ1Z/ChatGPT_Image_15_jun_2026,_04_07_55_p.m..png" alt="Sweet and Salty Puerto Rico" className="h-14 w-14 object-cover rounded-xl ring-1 ring-white/20" data-id="element-106" />
              <h3 className="font-heading text-2xl font-bold text-turquoise-light" data-id="element-107">
                Sweet & Salty
              </h3>
            </div>
            <p className="text-gray-300 mb-4 text-sm leading-relaxed" data-id="element-108">
              Rainforest Experiences
            </p>
            <div className="flex items-center gap-2 text-gray-300 text-sm mb-2" data-id="element-109">
              <MapPin size={16} className="text-turquoise" data-id="element-110" />
              <span data-id="element-111">{t.footer.locationRainforest}</span>
            </div>
            <a href="https://wa.me/19395296464" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-gray-300 text-sm mb-3 hover:text-white transition-colors" data-id="element-112">
              <Phone size={16} className="text-turquoise" data-id="element-113" />
              <span data-id="element-114">+1 (939) 529-6464</span>
            </a>
            <a href="https://www.instagram.com/sweetandsaltypuertorico/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-gray-300 text-sm hover:text-white transition-colors" data-id="element-115">
              <Instagram size={16} className="text-turquoise" data-id="element-116" />
              <span data-id="element-117">@sweetandsaltypuertorico</span>
            </a>
          </div>

          {/* Brand 2 */}
          <div data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/aifgHKgDB7GaFaemiHaRod/LOGO_PNG_ORIGI.png" alt="Blu Ocean Tours" className="h-20 w-auto object-contain mb-4 -ml-2" data-id="element-119" />
            <p className="text-gray-300 mb-4 text-sm leading-relaxed" data-id="element-120">
              Private Boat Tours
            </p>
            <div className="flex items-center gap-2 text-gray-300 text-sm mb-2" data-id="element-121">
              <MapPin size={16} className="text-turquoise" data-id="element-122" />
              <span data-id="element-123">{t.footer.locationBoat}</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300 text-sm mb-2" data-id="element-124">
              <Phone size={16} className="text-turquoise" data-id="element-125" />
              <span data-id="element-126">+1 (787) 672-2300</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300 text-sm mb-3" data-id="element-127">
              <Globe size={16} className="text-turquoise" data-id="element-128" />
              <a href="https://bluoceantours.com/booking/" target="_blank" rel="noreferrer" className="hover:text-white transition-colors" data-id="element-129">
                bluoceantours.com/booking
              </a>
            </div>
            <a href="https://www.instagram.com/bluoceantours/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-gray-300 text-sm hover:text-white transition-colors" data-id="element-130">
              <Instagram size={16} className="text-turquoise" data-id="element-131" />
              <span data-id="element-132">@bluoceantours</span>
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400" data-id="element-133">
          <p data-id="element-134">
            &copy; {new Date().getFullYear()} Sweet & Salty PR x Blu Ocean
            Tours. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>;
}